import { keyframes } from '@emotion/react'
import React, { CSSProperties } from 'react'
import { styled } from '../styles'

type LoadingDotsProps = {
  color?: string
  style?: Partial<CSSProperties>
  text?: string
}

const bounceDelay = keyframes`
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`

const LoadingDotsContainer = styled('div')({
  display: 'flex',
  height: 'inherit',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

const SpinnerContainer = styled('div')({
  width: '70px',
  textAlign: 'center',
})

const Bounce = styled('div')({
  width: '18px',
  height: '18px',
  backgroundColor: 'rgb(255, 218, 0)',
  borderRadius: '100%',
  display: 'inline-block',
  animation: `${bounceDelay} 1.4s infinite ease-in-out both`,
})

const Bounce1 = styled(Bounce)({
  animationDelay: '-0.32s',
})

const Bounce2 = styled(Bounce)({
  animationDelay: '-0.16s',
})

const Text = styled('span')({
  marginTop: '30px',
  textAlign: 'center',
})

export const LoadingDots: React.FunctionComponent<LoadingDotsProps> = (props) => (
  <LoadingDotsContainer {...(props.style && { style: props.style })}>
    <SpinnerContainer>
      <Bounce1 style={{ backgroundColor: props.color ? props.color : undefined }} />
      <Bounce2 style={{ backgroundColor: props.color ? props.color : undefined }} />
      <Bounce style={{ backgroundColor: props.color ? props.color : undefined }} />
    </SpinnerContainer>
    {props.text && <Text>{props.text}</Text>}
  </LoadingDotsContainer>
)

export default LoadingDots
